import { useState } from "react";
import { Hydratable } from "../../models/hydration/Hydratable";
import Model from "../../models/Model";
import { Button } from "../buttons/Button";
import { CommentList } from "../comments/CommentList";
import { HydratableModelError } from "../errorScreens/HydratableModelError";
import { AdvancedTooltip } from "../tooltips/AdvancedTooltip";
import {
  TTNotesPanel,
  TTNotesPanelButton,
} from "../tooltips/ConfigurationTooltips";
import { TooltipPanel } from "./TooltipPanel";

export { ModelNotesPanel };

type Props = {
  model: Hydratable<Model> | undefined;
  modelChanged: (modified: Model) => void;
};

const ModelNotesPanel = (props: Props) => {
  const [addingComment, setAddingComment] = useState(false);

  const model = props.model?.isHydrated()
    ? props.model.getHydrated()
    : undefined;

  return (
    <TooltipPanel
      title={"Notes"}
      tooltipText={TTNotesPanel}
      shortTooltip
      open
      sticky
      disableClick
      headerChildren={
        <AdvancedTooltip overflow tooltipText={TTNotesPanelButton}>
          {(tProps) => (
            <Button
              {...tProps}
              className={"white padded"}
              style={{ float: "right" }}
              disabled={model == undefined}
              onClick={(e) => {
                setAddingComment(true);
                e.stopPropagation();
              }}
            >
              Add Note
            </Button>
          )}
        </AdvancedTooltip>
      }
    >
      <>
        {model != undefined && (
          <CommentList
            newComment={addingComment}
            comments={model.comments}
            onChange={(comments) => {
              setAddingComment(false);
              model.setComments(comments);
              props.modelChanged(model);
            }}
          />
        )}
        {model == undefined && <HydratableModelError model={props.model} />}
      </>
    </TooltipPanel>
  );
};
